import { createContext, useContext } from 'react';

import { CurrentVariantStateContextType } from './model';

export const CurrentVariantStateContext =
  createContext<CurrentVariantStateContextType>({
    setVariant: () => {},
    setVariantList: () => [],
    setInitialSku: () => {},
    currentVariant: {
      variantId: '',
      barcodeNumber: '',
      title: '',
      variantSku: '',
      imageIndex: '',
      retailers: [],
    },
  });

export const useCurrentVariantStateContext = () =>
  useContext(CurrentVariantStateContext);
